var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 41,
    viewBox: "0 0 34 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28906 30.5031H32.7176M9.86049 9.0745H24.1462M9.86049 16.2174H24.1462M9.86049 23.3602H18.4319M29.8605 1.93164H4.14621C2.56826 1.93164 1.28906 3.21083 1.28906 4.78878V36.2174C1.28906 37.7954 2.56826 39.0745 4.14621 39.0745H29.8605C31.4385 39.0745 32.7176 37.7954 32.7176 36.2174V4.78878C32.7176 3.21083 31.4385 1.93164 29.8605 1.93164Z",
    stroke: "#0E9349",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrip);
export default __webpack_public_path__ + "static/media/trip.e17039df741db6f44b48331530e39424.svg";
export { ForwardRef as ReactComponent };